"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

function anonymous(locals, escapeFn, include, rethrow) {
  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  __append("<div class=\"Swiper Swiper--pagination-");

  __append(escapeFn(this.props.pagination));

  __append("\">\n    <div class=\"Swiper__wrapper ");

  __append(escapeFn(this.getSwiperFadeClasses()));

  __append("\" style=\"");

  __append(escapeFn(this.getWrapperStyle()));

  __append("\">\n        <div class=\"Swiper__container\" style=\"");

  __append(escapeFn(this.getContainerStyle()));

  __append("\">\n            ");

  __append(this.body);

  __append("\n        </div>\n    </div>\n\n    ");

  if (this.position.getPages().length > 1) {
    ;

    __append("\n        ");

    if (this.props.pagination === 'arrows' || this.props.pagination === 'mobile-dots' || this.props.pagination === 'arrows-and-dots') {
      ;

      __append("\n            <div class=\"Swiper__arrow-left");

      __append(escapeFn(this.isBegining() ? ' Swiper__arrow-left--disabled' : ''));

      __append("\" onclick=\"this.previousPage()\"><i class=\"IKEA--icon-chevron-left\"></i></div>\n            <div class=\"Swiper__arrow-right");

      __append(escapeFn(this.isEnd() ? ' Swiper__arrow-right--disabled' : ''));

      __append("\" onclick=\"this.nextPage()\"><i class=\"IKEA--icon-chevron-right\"></i></div>\n        ");
    }

    ;

    __append("\n\n        ");

    if (this.props.pagination == 'mobile-dots' || this.props.pagination === 'dots' || this.props.pagination === 'arrows-and-dots') {
      ;

      __append("\n            <div class=\"Swiper__dots\">\n                ");

      for (var i = 0, max = this.position.getPages().length; i < max; i++) {
        ;

        __append("\n                    ");

        if (i === this.position.getPageIndex()) {
          ;

          __append("\n                        <div class=\"Swiper__dots-item Swiper__dots-item--selected\"></div>\n                    ");
        } else {
          ;

          __append("\n                        <div class=\"Swiper__dots-item\" onclick=\"this.slideTo(");

          __append(escapeFn(i));

          __append(")\"></div>\n                    ");
        }

        ;

        __append("\n                ");
      }

      ;

      __append("\n            </div>\n        ");
    }

    ;

    __append("\n    ");
  }

  ;

  __append("\n</div>\n");

  return __output;
}